export default __webpack_public_path__ + "static/media/download.158739c3.webp";